import styled from 'styled-components'
/**
 * Styled component is used to decorate SplashScreen component.
 * Props are passed from ThemeProvider component.
 */
export const ConditionSelectionPageStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  height: 300px;
`
